module.exports = __webpack_public_path__ + "static/perfectly-reasonable-deviations-from-the-beaten-track-6832a298c4ee6448e7fe212cc781130f.jpg";